import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
    © 2023, Powered by Ananta Futuristic Solutions Private Limited (V 3.0 RO)
     </span>
  `,
})
export class FooterComponent {
  
}
